// Local User interface for UI components
export interface User {
    id: number;
    apiId: string; // Original API ID for backend operations
    status: 'Active' | 'InActive';
    username: string;
    roles: string[];
    changed: string;
    access: string;
}

// API User interface matching the backend response
export interface ApiUser {
    id: string;
    email: string;
    username: string;
    is_active: boolean;
    profile_picture: string;
    created_at: string;
    roles: string[];
    last_updated: string;
    last_access_at: string;
}

export const statusColors = {
    Active: { color: '#1DAB51', bg: '#B4F6D3' },
    InActive: { color: '#A3871E', bg: '#FFF1C0' },
} as const; 